/**
 * FormSuccess Component
 * Standardized success message display with icon and animations
 * Provides consistent success styling across all forms
 */

import { type ReactNode } from 'react';
import { cn } from '../../lib/utils';

export interface FormSuccessProps {
  children: ReactNode;
  className?: string;
  variant?: 'inline' | 'banner';
}

export function FormSuccess({
  children,
  className,
  variant = 'banner',
}: FormSuccessProps) {
  if (variant === 'inline') {
    return (
      <p className={cn('mt-1 text-sm text-green-600', className)} role="status">
        {children}
      </p>
    );
  }

  return (
    <div
      className={cn(
        'rounded-md bg-green-50 p-4 border border-green-200',
        className
      )}
      role="status"
    >
      <div className="flex">
        <div className="flex-shrink-0">
          <svg
            className="h-5 w-5 text-green-400"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.236 4.53L7.53 10.53a.75.75 0 00-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <div className="ml-3">
          <p className="text-sm font-medium text-green-800">{children}</p>
        </div>
      </div>
    </div>
  );
}
